import { GetSearchItemInfoResponse } from '../types';

/**
 * Checks if a search item can be selected based on its disabled state
 * Only applies the disabled check when in modal search mode
 * @param searchItemInfo - The search item info from getSearchItemInfo
 * @param isModalSearch - Whether the search is in modal mode
 * @returns true if the item can be selected, false otherwise
 */
export const canSelectSearchItem = (
  searchItemInfo: GetSearchItemInfoResponse | undefined,
  isModalSearch?: boolean,
): boolean => {
  // If not in modal mode, always allow selection (disabled is just visual)
  if (!isModalSearch) {
    return true;
  }
  
  if (!searchItemInfo) {
    return true; // If no info provided, allow selection
  }
  
  // In modal mode, check if the item is explicitly disabled
  if (searchItemInfo.disabled === true) {
    return false;
  }
  
  return true;
};
